<template>
    <div id="info-container" style="min-width: 50vw;">
        <div class="vertical">
            <p>{{ system.systemName }}</p>
            <div class="info-field horizontal">
                <tr class="info-field-row" style="align-items: center; display: flex;">
                    <td style="text-align: left; width: 30%;" class="info-field-title">{{ $t('Description') }}</td>
                    <td style="text-align: right; width: 100%; height: 150px;" class="info-field-value">
                        <textarea style="padding: 10px;" v-model="description" type="text" :placeholder="$t('Description')"/>
                    </td>
                </tr>
            </div>
            <div>
                <div class="error" v-if="error != ''">{{ error }}</div>
            </div>
            <div style="align-self: center;">
                <Button :title="'Save'" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
            </div>
        </div>    
    </div>
</template>

<script>
import { getTodayCheckupForSystem, updateSystemCheckupDone } from '../../api/api';
import Button from '../Button.vue';

export default {
    components: {
        Button
    },
    props: {
        system: {
            type: Object,
            default() {
                return {}
            },
            required: true
        },
    },
    data() {
        return {
            lastCheckup: {},
            error: '',
            description: ''
        }
    },
    methods: {
        async getData() {
            try {
                var response = await getTodayCheckupForSystem(this.system.systemId)
                this.description = response.data.description;
            } catch (ex) {
                if (ex.response.data.error.includes('System')) {
                    this.error = ex.response.data.error;
                }
            }
        },
        async save() {
			await updateSystemCheckupDone({SystemId: this.system.systemId, Description: this.description});
            this.$emit('save')
        }
    },
    async mounted() {
        this.getData();
    }
}
</script>

<style scoped>
.error {
    text-align: left !important;
    color: #FD8282;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

#info-container {
    padding: 20px;

    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;

    justify-content: space-between;
    display: flex;
    flex-direction: column;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    padding-right: 20px;
    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

textarea {
    border: none;
    width: 100%;
}

textarea:focus {
    border-bottom: 1px solid #0095b2;
    outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Systems/CheckupModal.vue